module.exports = __webpack_public_path__ + "static/img/ecotemp1-max.06441fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refs/eco/ecotemp1-max.jpg
// module id = yvCZ
// module chunks = 0